import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import { Popover } from '../../Popover';
import debounce from 'lodash/debounce';

export interface ISearchesNotificatorProps {
  disableHref?: boolean;
  title: string;
  notifications?: number;
  link?: string | null;
  iconView: React.ReactElement;
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export interface IState {
  isOpen: boolean;
}

export class Icon extends React.Component<ISearchesNotificatorProps, IState> {
  public constructor(props: ISearchesNotificatorProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  public componentWillUnmount() {
    this.debouncedFnsCancel();
  }

  public render() {
    const { title, notifications, link, disableHref, iconView } = this.props;

    const { isOpen } = this.state;
    const count = Number(notifications || 0);
    const popoverCssClassName = `icon-popover${isOpen ? '' : ' hidden'}`;

    return (
      <a
        {...mergeStyles(
          'c-header-messages-container',
          (count === 0 && 'c-header-messages-container--inactive') || undefined,
        )}
        href={disableHref ? undefined : link || '#'}
        target="_blank"
        onClick={this.handleIconClick}
      >
        <div
          className="c-header-messages--adaptive c-header-messages-icon-container"
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          <span {...mergeStyles((count > 0 && 'c-header-active-notification') || undefined)} data-count={count} />
          {iconView}
        </div>
        {title.length > 0 && (
          <Popover
            isActive={isOpen}
            cssClass={popoverCssClassName}
            cssClassContainer="icon-popover-container"
            isShowCenterByParent={true}
            parentWidth={16}
          >
            <span>{title}</span>
          </Popover>
        )}
      </a>
    );
  }

  private readonly handleIconClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { onClick } = this.props;

    onClick(event);
    this.setState({ isOpen: false });
  };

  private readonly onMouseLeave = () => {
    this.debouncedFnsCancel();

    const { isOpen } = this.state;

    if (isOpen) {
      this.debouncedHandleHide();
    }
  };

  private readonly onMouseEnter = () => {
    this.debouncedFnsCancel();

    const { isOpen } = this.state;

    if (!isOpen) {
      this.debouncedHandleShow();
    }
  };

  private readonly handleShow = () => {
    this.setState({
      isOpen: true,
    });
  };

  private readonly handleHide = () => {
    this.setState({
      isOpen: false,
    });
  };

  private readonly debouncedHandleShow = debounce(this.handleShow, 200);

  private readonly debouncedHandleHide = debounce(this.handleHide, 200);

  private debouncedFnsCancel() {
    this.debouncedHandleShow.cancel();
    this.debouncedHandleHide.cancel();
  }
}
